<template>
    <v-card flat v-if="products && products.length">
        <v-card-title class="primary-transparent-5 title">
            <span>{{ 'You might also be interested in' | translation }}</span>

            <v-spacer/>

            <v-icon>flag</v-icon>
        </v-card-title>

        <template v-for="(product, index) in products">
            <related-products-thumbnail
                class="pa-2"
                :product="product"
                target="Related Products"
                :key="`related-product-${product.id}`"
                v-if="product.isNotBuyable[product.id] === false"
            />

            <v-divider :key="`product-upgrade-divider-${product.id}`"/>
        </template>
    </v-card>
</template>

<script>
    import {Observable} from 'rxjs';
    import {getProducts} from './store/getProducts';

    const name = 'RelatedProducts';

    export default {
        name: name,
        props: [
            'productIds'
        ],
        data(){
            return {
                products: [],
                productsSubscriber: null,
            };
        },
        created() {
            this.productsSubscriber = getProducts(new Observable(subscriber => this.$watch(
                'productIds',
                (ids) => subscriber.next({
                    ids,
                }),
                {
                    immediate: true,
                }
            )))
                .subscribe(products => this.products = products);
        },
        beforeDestroy() {
            this.productsSubscriber.unsubscribe();
        }
    };
</script>